import type { GetUsersRequestProps } from '@services/api/users/types'
import type { UserDataModalFormProps } from '../context/types'

export const parseGetUsersPayload = (formData: UserDataModalFormProps) => {
  const payload: GetUsersRequestProps = {
    bodyParams: {
      onlyActive: false,
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType,
      sortType: formData.sortType,
      codeFilter: formData.code ? formData.code.toString() : null,
      userNameFilter: formData.user ? formData.user : null,
      positionFilters: formData.role ? (formData.role === 'Todos' ? null : [formData.role]) : null,
      profileFiltersById: formData.profile ? (formData.profile === '0' ? null : [Number(formData.profile)]) : null
    }
  }

  return payload
}
